<template>
    <div class="fondo">
        <v-container style="margin: 0 auto ; max-width: 65rem; width: 100%;">
            <v-form ref="form" v-model="valid" @submit.prevent="submitForm">
                <div>
                    <v-card class="mb-4" style="color: #0F57AC;padding: 1.9rem ">
                            <h1 class="titulo-from">
                                CONTROL DE ENDOTOXINAS EN LIQUIDO DE DIALIZADO
                            </h1>
                    </v-card>
                    <el-form :model="encuestaForm" label-position="top" :rules="rules" ref="encuestaForm">
                        <v-card class="mb-4">
                            <h3 style="margin-bottom: 1rem;">INFORME DE MICROBIOLOGÍA</h3>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Método" :label-width="formLabelWidth" prop="metodo">
                                        <el-input v-model="encuestaForm.metodo" autocomplete="off" disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Sensibilidad" :label-width="formLabelWidth"
                                        prop="sensibilidad">
                                        <el-input v-model="encuestaForm.sensibilidad" autocomplete="off"
                                            disabled></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Fecha de muestreo" :label-width="formLabelWidth"
                                        prop="fecha_muestreo">
                                        <el-date-picker style="width: 100%;" v-model="encuestaForm.fecha_muestreo"
                                            type="date" placeholder="Fecha de Muestreo" :editable=false>
                                        </el-date-picker>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <el-form-item label="Lugar de toma" :label-width="formLabelWidth" prop="ipress">
                                        <el-select v-model="encuestaForm.ipress" filterable placeholder="IPRESS"
                                            style="width: 100%;" disabled>
                                            <el-option v-for="item in arrayClinica" :key="item.value"
                                                :label="item.descripCas" :value="item.id_cas">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Ultrapura
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="ultrapura_max">
                                        <el-input v-model="encuestaForm.ultrapura_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template>
                                        </el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel de Acción: " :label-width="formLabelWidth"
                                        prop="purificada_accion">
                                        <el-input v-model="encuestaForm.purificada_accion" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                                <v-col cols="12" lg="4" md="6">
                                    <h3>
                                        Agua Purificada
                                    </h3>
                                    <el-form-item label="Nivel Máximo permitido" :label-width="formLabelWidth"
                                        prop="purificada_max">
                                        <el-input v-model="encuestaForm.purificada_max" autocomplete="off"
                                            disabled><template #append> UE/ml </template></el-input>
                                    </el-form-item>
                                </v-col>
                            </v-row>
                        </v-card>
                        <v-card class="mb-4">
                            <h3>RESULTADOS</h3>
                           
                            <div v-for="(item, index) in encuestaForm.resultados" :key="index">
                                <v-row style="margin-top: 1rem;">
                                    <v-col cols="12" lg="3" md="6">
                                        <el-form-item :label="'Sala'" :label-width="formLabelWidth"
                                            :prop="'sala' + (index + 1)">
                                            <el-input v-model="item.sala" autocomplete="off"
                                                :disabled="item.status"></el-input>
                                        </el-form-item>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6">
                                        <el-form-item :label="'Nro Maquina'" :label-width="formLabelWidth"
                                            :prop="'nro_maquina' + (index + 1)">
                                            <el-input v-model="item.nro_maquina" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6">
                                        <el-form-item :label="'Nro Serie'" :label-width="formLabelWidth"
                                            :prop="'nro_serie' + (index + 1)">
                                            <el-input v-model="item.nro_serie" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6">
                                        <el-form-item :label="'Resultados'" :label-width="formLabelWidth"
                                            :prop="'resultados' + (index + 1)">
                                            <el-input v-model="item.resultados" autocomplete="off"></el-input>
                                        </el-form-item>
                                    </v-col>
                                </v-row>
                            </div>
                            <!-- Botón para agregar otro grupo de inputs -->
                            <i class="el-icon-circle-plus" @click="agregarFila" color="success" style="font-size: 2.5rem;color: #409EFF;cursor: pointer;"></i>
                            <i class="el-icon-remove" @click="quitarFila" v-if="encuestaForm.resultados.length>4" style="font-size: 2.5rem;color: #F56C6C;cursor: pointer;"></i>

                        </v-card>
                    </el-form>
                </div>
                <v-btn color="primary" type="submit">Enviar</v-btn>
            </v-form>
        </v-container>
    </div>
</template>
<script>
import Swal from 'sweetalert2';
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
    data() {
        return {
            arrayClinica: [],
            formLabelWidth: "15px",
            encuestaForm: {
                metodo: "Limulus Amebocyte Lysate (LAL) Semicuantitativo",
                ipress: 1,
                sensibilidad: "0.03 EU/mL",
                ultrapura_max: "< 0.03 EU/mL",
                purificada_accion: "0.25 EU/mL",
                purificada_max: "< 0.5 EU/mL",
                fecha_muestreo: null,
                osmosis_resultado: null,
                sala_resultado: null,
                anillo_resultado: null,
                sala1: 1,
                nro_maquina1: null,
                nro_serie1: null,
                resultados1: null,
                sala2: 2,
                nro_maquina2: null,
                nro_serie2: null,
                resultados2: null,
                sala3: 3,
                nro_maquina3: null,
                nro_serie3: null,
                resultados3: null,
                sala4: 4,
                nro_maquina4: null,
                nro_serie4: null,
                resultados4: null,
                resultados: [
                    { sala: 'SALA 1', nro_maquina: '', nro_serie: '', resultados: '', status: true },
                    { sala: 'SALA 2', nro_maquina: '', nro_serie: '', resultados: '', status: true },
                    { sala: 'SALA 3', nro_maquina: '', nro_serie: '', resultados: '', status: true },
                    { sala: 'SALA 4', nro_maquina: '', nro_serie: '', resultados: '', status: true },
                ]
            },
            selectedSection: 'Su salud',
            valid: false,
            formData: {},
            rules: {
                required: v => !!v || "Este campo es obligatorio",
            },
            opcionesTabla1: ["Ninguna", "Leve", "Moderada", "Severa", "Extrema o no puede hacerlo"],
            opciones: ["Derecha", "Izquierda", "No Aplica"],
            respuestas: Array(12).fill(""),
        };
    },
    created() {
        this.loadIpress();
    },
    methods: {
        quitarFila() {
            if (this.encuestaForm.resultados.length > 0) {
                this.encuestaForm.resultados.pop();
            }
        },
        menosFila() {
            this.encuestaForm.resultados.push({
                sala: '',
                nro_maquina: '',
                nro_serie: '',
                resultados: '',
                status: false
            });
        },
        agregarFila() {
            this.encuestaForm.resultados.push({
                sala: '',
                nro_maquina: '',
                nro_serie: '',
                resultados: '',
                status: false
            });
        },
        loadIpress() {
            axios
                .post(RUTA_API + "/api/token/", {
                    username: USUARIO,
                    password: PASSWORD,
                })
                .then((response) => {
                    this.auth = "Bearer " + response.data.access;
                    axios
                        .post(RUTA_API + "/generar_lista_ipress/", { "tipoCas": 2 }, {
                            headers: { Authorization: this.auth },
                        })
                        .then((res) => {
                            this.arrayClinica = res.data;
                        })
                        .catch((res) => {
                            /* this.dialog = false; */
                        });
                })
                .catch((response) => {
                    response === 404
                        ? console.warn("lo sientimos no tenemos servicios")
                        : console.warn("Error:", response);
                });
        },
        submitForm() {
            console.log("envio formulario ", this.encuestaForm);
        },
    },
};
</script>

<style scoped>
/* Para tablets */
@media (max-width: 768px) {
    .titulo-from {
        font-size: 28px;
    }
}

/* Para celulares */
@media (max-width: 480px) {
    .card-titulo {
        padding: 1.4rem !important;
    }

    .titulo-from {
        font-size: 23px;
        line-height: 1.8rem;
    }
}

::v-deep .el-form-item__label {
    line-height: 0px !important;
}

.v-card {
    padding: 2rem;
    border-radius: 12px;
    background:
        linear-gradient(180deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 15%, rgb(255, 255, 255) 100%)
}

.fondo {
    background: url(https://cdn.forms.office.net/images/aio/wave-pattern-v1.svg) center top / cover no-repeat, linear-gradient(180deg, #0F57AC 0%, rgba(3, 98, 206, 0.935) 100%);
    background-attachment: fixed;
    /* Fija el fondo al hacer scroll */
}
</style>